// import React, { useEffect, useRef } from "react";

// const ListboxComponent = React.forwardRef(function ListboxComponent(
//   props,
//   ref
// ) {
//   const { children, onScrollBottom, ...other } = props;
//   const listRef = useRef();

//   useEffect(() => {
//     const node = listRef.current;
//     if (!node) return;

//     const handleScroll = (event) => {
//       const el = event.currentTarget;
//       const scrollBottom =
//         el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

//       if (scrollBottom && typeof onScrollBottom === "function") {
//         onScrollBottom();
//       }
//     };

//     node.addEventListener("scroll", handleScroll);
//     return () => node.removeEventListener("scroll", handleScroll);
//   }, [onScrollBottom]);

//   return (
//     <ul
//       {...other}
//       ref={(node) => {
//         listRef.current = node;
//         if (typeof ref === "function") ref(node);
//         else if (ref) ref.current = node;
//       }}
//     >
//       {children}
//     </ul>
//   );
// });

// export default ListboxComponent;


import React, { useEffect, useLayoutEffect, useRef } from "react";

const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
  const { children, onScrollBottom, ...other } = props;
  const listRef = useRef(null);
  const scrollTopRef = useRef(0);

  // Save scrollTop BEFORE re-render
  useLayoutEffect(() => {
    const list = listRef.current;
    if (list) {
      scrollTopRef.current = list.scrollTop;
    }
  });

  // Restore scrollTop AFTER re-render
  useEffect(() => {
    const list = listRef.current;
    if (list) {
      list.scrollTop = scrollTopRef.current;
    }
  });

  useEffect(() => {
    const node = listRef.current;
    if (!node) return;

    const handleScroll = (e) => {
      const el = e.currentTarget;
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
      if (atBottom && typeof onScrollBottom === "function") {
        onScrollBottom();
      }
    };

    node.addEventListener("scroll", handleScroll);
    return () => node.removeEventListener("scroll", handleScroll);
  }, [onScrollBottom]);

  return (
    <ul
      {...other}
      ref={(node) => {
        listRef.current = node;
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
      }}
      style={{
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      {children}
    </ul>
  );
});

export default ListboxComponent;

